const initialState = {
    data: {
        memberId: 'N-N',
        totalSupply: 'N-N',
        balanceOf: 'N-N',
        buyPrice: 'N-N',
        sellPrice: 'N-N',
        buyPriceUsd: 'N-N'
    }
}

const tokenReducer = (state = initialState, action) => {
    if (action.type === 'INIT_TOKEN'){
        return Object.assign({}, state, {
            data: action.payload
        })
    }
  
    if (action.type === 'TOKEN_LOGGED_OUT'){
        return Object.assign({}, state, {
            data: {
                memberId: 'N-N',
                totalSupply: 'N-N',
                balanceOf: 'N-N',
                buyPrice: 'N-N',
                sellPrice: 'N-N',
                buyPriceUsd: 'N-N'
            }
        })
    }

    return state
}

export default tokenReducer



// WEBPACK FOOTER //
// ./src/user/tokenReducer.js